import $http from 'axios';

export const SalesRepo = {
  management: {
    all: (params: any) => $http.get('/consultings', { params }),
    update: (id: number, params: any) =>
      $http.put(`/consultings/${id}`, params),
  },
};
